import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class FinancialAccountRrifType extends Enum {
  static ANNUITANT = {
    key: 'annuitant',
    get value() {
      return Lang.t('financialaccount.annuitant');
    },
    get lowercaseValue() {
      return Lang.t('financialaccount.27bfa49d-9509-4b57-a351-e5301ad3c86f');
    }
  };

  static NAMED_BENEFICIARIES = {
    key: 'named_beneficiaries',
    get value() {
      return Lang.t('financialaccount.named-beneficiaries');
    },
    get lowercaseValue() {
      return Lang.t('financialaccount.8fd4b0b0-172a-4728-9b49-6730630ddf96');
    }
  };

  static NONE = {
    key: 'none',
    get value() {
      return Lang.t('financialaccount.none');
    },
    get lowercaseValue() {
      return Lang.t('financialaccount.1049ff99-bd57-4385-ad1d-e476aa8e098f');
    }
  };

  /**
   * @param {Estate} estate
   * @returns {Enum}
   */
  static showOptionsForEstate(estate) {
    return estate.contact.hasPartner
      ? FinancialAccountRrifType.getValues()
      : [FinancialAccountRrifType.NAMED_BENEFICIARIES, FinancialAccountRrifType.NONE];
  }
}
